import {
  LocalTrackData,
  useLocalTracks,
} from 'components/calls/tracks/use_local_tracks'
import { useMemo } from 'react'
import { LocalParticipant, Room } from 'twilio-video'

type UseLocalParticipant = {
  localParticipant: LocalParticipant | undefined
  localTrackData: LocalTrackData
}

export const useLocalParticipant = (
  room?: Room | null,
): UseLocalParticipant => {
  const localTrackData = useLocalTracks(room, room?.localParticipant)

  return useMemo(() => {
    return {
      localParticipant: room?.localParticipant,
      localTrackData,
    }
  }, [localTrackData, room])
}
